import gsap from "gsap";

export default {
  init() {
    const articles = document.querySelectorAll(".event-list.has-image");
    for (const article of articles) {
      const trigger = article.querySelector(".event-list__action--image");
      const overlay = article.querySelector(".event-list__lightbox-overlay");
      const lightbox = article.querySelector(".event-list__lightbox");
      const image = lightbox?.querySelector("img");
      const closeButton = article.querySelector(".event-list__lightbox-close");
      const closeTriggers = article.querySelectorAll(
        ".event-list__lightbox-close, .event-list__lightbox-overlay"
      );

      if (!trigger || !overlay || !lightbox || !image) {
        continue;
      }

      trigger.addEventListener("click", () => {
        gsap.to(overlay, {
          duration: 0.2,
          opacity: 1,
          ease: "power2.inOut",
        });

        gsap.fromTo(
          lightbox,
          { opacity: 0, scale: 0.95 },
          {
            duration: 0.2,
            opacity: 1,
            scale: 1,
            ease: "power2.inOut",
          }
        );

        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        overlay.style.pointerEvents = "auto";
        lightbox.style.pointerEvents = "auto";
        if (closeButton) {
          closeButton.style.pointerEvents = "auto";
        }
        image.style.pointerEvents = "auto";
      });

      for (const closeTrigger of closeTriggers) {
        closeTrigger.addEventListener("click", () => {
          gsap.to(overlay, {
            duration: 0.2,
            opacity: 0,
            ease: "power2.inOut",
          });

          gsap.to(lightbox, {
            duration: 0.2,
            opacity: 0,
            ease: "power2.inOut",
            onComplete: () => {
              document.body.style.overflow = "";
              document.body.style.paddingRight = "";
              overlay.style.pointerEvents = "none";
              lightbox.style.pointerEvents = "none";
              if (closeButton) {
                closeButton.style.pointerEvents = "none";
              }
              image.style.pointerEvents = "none";
            },
          });
        });
      }
    }
  },
};
